import * as angular from "angular";
import {IController} from "angular";

export class ProgramVehiclesByDistanceTableCtrl implements IController {

  vehicleData: any;
  isExpanded: boolean;
  serviceAreasOptionIds: string[];
  excludeServiceAreasIds: string[];
  onUpdateTier: Function;
  onDeleteTier: Function;

  public siteDistanceUnit: any;
  public dataReferenceId: string;

  /* @ngInject */
  constructor() {

  }

  $onChanges(changes) {
    if (changes.vehicleData) {
      if (this.vehicleData) {
        this.dataReferenceId = this.vehicleData.data ? 'data' : 'parentData';
      }
    }
  };

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehiclesByDistanceTable', {
    require: {
      form: '^form'
    },
    bindings: {
      vehicleData: '<',
      isExpanded: '<?',
      isEdit: '<?',
      onUpdateTier: '&',
      onDeleteTier: '&'
    },
    template: require('./program-vehicles-by-distance-table.html').default,
    controller: ProgramVehiclesByDistanceTableCtrl
  });
